import { setTerms } from './helpers';

export const setBuildingLiftTypesType = setTerms('building_lift_types_type');
